'use client';

import type { FC } from 'react';
import { useState } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import ClaimAllIcon from '@wwe-portal/ui/components/icons/claim-all-icon';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@wwe-portal/ui/components/tooltip';

export const ClaimAllIconWithToolTip: FC<{
  tooltipContent: string;
}> = ({ tooltipContent }) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Tooltip onOpenChange={setOpen} open={open}>
        <TooltipTrigger asChild>
          <ClickableDiv
            onClick={(e) => {
              e.stopPropagation();
              setOpen((currentOpen) => !currentOpen);
            }}
          >
            <ClaimAllIcon />
          </ClickableDiv>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent className="max-w-48 overflow-auto break-words">
            {tooltipContent}
            <TooltipArrow />
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </div>
  );
};
